import { BankAccountModel } from 'api-hooks/bank-account';
import React from 'react';

import { BankAccountFormType } from '../components/form-type';

export default function useBankAccountDefaultValues(
  bankAccount?: BankAccountModel,
): BankAccountFormType {
  const defaultValues = React.useMemo<BankAccountFormType>(() => {
    return {
      accountNumber: bankAccount?.accountNumber || '',
      balance: bankAccount?.balance || 0,
      code: bankAccount?.code || '',
      description: bankAccount?.description || '',
      name: bankAccount?.name || '',
      bankAccount,
    };
  }, [bankAccount]);

  return defaultValues;
}
